import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { StockAlertList } from '../../components/warehouse/StockAlertList';
import { ThresholdConfigPanel } from '../../components/warehouse/ThresholdConfigPanel';

type TabType = 'alerts' | 'thresholds';

export const StockAlertPage: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<TabType>('alerts');

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-8 w-8 text-red-600" />
          <h1 className="text-2xl font-bold text-gray-900">
            {t('warehouse.stockAlerts.title')}
          </h1>
        </div>
        <p className="mt-2 text-sm text-gray-600">
          {t('warehouse.stockAlerts.description')}
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab('alerts')}
            className={`whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
              activeTab === 'alerts'
                ? 'border-red-500 text-red-600'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
            }`}
          >
            {t('warehouse.stockAlerts.activeAlerts')}
          </button>
          <button
            onClick={() => setActiveTab('thresholds')}
            className={`whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
              activeTab === 'thresholds'
                ? 'border-red-500 text-red-600'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
            }`}
          >
            {t('warehouse.stockAlerts.thresholdConfig')}
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === 'alerts' && <StockAlertList />}
        {activeTab === 'thresholds' && <ThresholdConfigPanel />}
      </div>
    </div>
  );
};
